var _defs, _path, _path2, _path3, _path4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeometricDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    fill: "none",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gA",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a78bfa",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6366f1",
    stopOpacity: 0.008
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-120 560 L440 170 L820 860 Z",
    fill: "#ffffff",
    fillOpacity: 0.008
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1320 110 L640 430 L1320 880 Z",
    fill: "url(#gA)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-60 660 L470 210 L980 800",
    stroke: "#ffffff",
    strokeOpacity: 0.04,
    strokeWidth: 1.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1280 90 L620 470 L1320 860",
    stroke: "#c4b5fd",
    strokeOpacity: 0.04,
    strokeWidth: 1.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 990,
    cy: 180,
    r: 340,
    stroke: "#c4b5fd",
    strokeOpacity: 0.03,
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeometricDark);
export default __webpack_public_path__ + "static/media/geometric-dark.94d709d81791b2d5ff3cf39aefa6bdec.svg";
export { ForwardRef as ReactComponent };